// @ts-nocheck
import React, { useState } from 'react';
import PlatformsList from './components/PlatformsList';
import ActionBar from '../../layout/ActionBar';
import EditPlatform from './slideout/EditPlatform';
import SlidingPane from 'react-sliding-pane';
import Button from '../../common/Button';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../../../util/pageTitle';

function Platforms() {
  const [pageTitle, setPageTitle] = usePageTitle(['Platforms', 'Settings']);
  const { t } = useTranslation();
  const [reload, setReload] = useState<Date | undefined>();
  const [addPlatformSlideoutOpen, setAddPlatformSlideoutOpen] = useState(false);

  return (
    <>
      <ActionBar>
        <Button
          className="btn btn-primary"
          onClick={() => setAddPlatformSlideoutOpen(true)}
          text={t('Add platform')}
          testId="add-platform-button"
        />
      </ActionBar>

      <PlatformsList reload={reload} />
      <SlidingPane
        isOpen={addPlatformSlideoutOpen}
        hideHeader={true}
        from="right"
        className="side-panel"
        onRequestClose={() => setAddPlatformSlideoutOpen(false)}
      >
        <EditPlatform
          done={(d) => {
            setReload(new Date());
            setAddPlatformSlideoutOpen(false);
          }}
          cancel={() => setAddPlatformSlideoutOpen(false)}
        />
      </SlidingPane>
    </>
  );
}

export default Platforms;
